<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useRoute, useRouter } from 'vue-router'
import { NXGRetailPosPageHeader } from '@nsftx/seven-nxg-retail-vue-sdk/ui'
import { useHeaderStore } from '@/stores/header/headerStore'
import { useLastVisitedGame } from '@/composables/useLastVisitedGame/useLastVisitedGame'
import { useI18n } from 'vue-i18n'

interface PageHeaderEmits {
  clickLastVisitedGame: [gameId: string]
}

const emit = defineEmits<PageHeaderEmits>()

const { t } = useI18n({ useScope: 'global' })
const route = useRoute()
const router = useRouter()
const headerStore = useHeaderStore()
const { pageTitle } = storeToRefs(headerStore)
const { openMainMenu } = headerStore
const { lastVisitedGame } = useLastVisitedGame()

const showCloseButton = computed(() => route.meta.pageHeaderClose === true)

const backLabel = computed(() => {
  if (showCloseButton.value || !lastVisitedGame.value) {
    return undefined
  }

  return `${t('common_back')} ${lastVisitedGame.value.name}`
})

const handleBackClick = () => {
  if (showCloseButton.value) {
    router.back()
    return
  }

  if (!lastVisitedGame.value) {
    return
  }

  emit('clickLastVisitedGame', lastVisitedGame.value.id)
}
</script>

<template>
  <div data-testid="ss-page-header">
    <NXGRetailPosPageHeader
      :title="$t(pageTitle)"
      :back-label="backLabel"
      :show-close-button="showCloseButton"
      @toggle-menu-click="openMainMenu"
      @back-click="handleBackClick"
    />
  </div>
</template>
